import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function UnverifiedIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M10.59 1.52a2.17 2.17 0 0 1 2.82 0l.008.008C15.058 2.96 17.323 4 19 4a2 2 0 0 1 2 2v7c0 1.172-.176 2.238-.507 3.205a1 1 0 0 1-1.654.383L7.292 5.012a1 1 0 0 1 .318-1.627 11.4 11.4 0 0 0 2.972-1.858zM21.707 22.293a1 1 0 0 1-1.414 1.414l-3.104-3.104c-1.335.995-2.902 1.727-4.52 2.291l-.008.003a2 2 0 0 1-1.327-.015c-2.154-.745-4.231-1.794-5.778-3.378C3.979 17.889 3 15.764 3 13V6.414L.293 3.707a1 1 0 0 1 1.414-1.414z" />
    </Icon>
  );
}

UnverifiedIcon.displayName = 'UnverifiedIcon';
